const messageAlert = (companyAudit) => {
  const dataProcessIdSampling = companyAudit?.dataProcessIdSampling?.length || 0
  const processesOnAudit = companyAudit?.processesOnAudit || 0
  const sampling = companyAudit?.sampling || 0
  const textFixed =
    "A seleção dos processos baseia-se em critérios específicos: o status deve ser 'Aprovado' " +
    `e a última atualização deve ter ocorrido há, no mínimo, ${
      companyAudit?.thresholdMonth || 'x'
    } meses. ` +
    `A amostragem padrão é de ${sampling}%. No entanto, para garantir a relevância da auditoria, ` +
    'o sistema selecionará pelo menos 2 processos caso a porcentagem definida resulte em um número inferior. ' +
    'Se não houver processos adequados que atendam aos critérios de seleção, a auditoria será finalizada automaticamente.'

  if (
    processesOnAudit <= 0 &&
    ['finalized', 'inactive'].includes(companyAudit?.status)
  ) {
    const text =
      'Não foram identificados processos adequados para a auditoria. Para os processos estarem ' +
      "adequados, devem estar com status 'Aprovado' e a última atualização deve ter ocorrido " +
      `há pelo menos ${companyAudit?.thresholdMonth} meses.`
    return text
  }

  if (processesOnAudit > 0 && dataProcessIdSampling > 0) {
    const text =
      `Foram identificados ${dataProcessIdSampling} processos adequados para a auditoria e, ` +
      `de acordo com a amostragem definida em ${sampling}%, ${processesOnAudit} processos foram selecionados para a auditoria. ` +
      textFixed
    return text
  }

  if (processesOnAudit > 0) {
    const text =
      `De acordo com a amostragem definida em ${sampling}%, ${processesOnAudit} processos foram selecionados para a auditoria. ` +
      textFixed
    return text
  }

  return textFixed
}

export default messageAlert
